import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';
import type { BadgeIcon } from '../../components/values/values.types';

/** The icons of the Rights module. */
class RightsIconsClass {
    /** Every level with its look: its icon and colour. */
    public readonly Levels: Record<number, BadgeIcon> = {
        1: { icon: Icons.Eye, state: 'view' },
        2: { icon: Icons.FilePlus, state: 'link' },
        3: { icon: Icons.Pencil, state: 'edit' },
        4: { icon: Icons.Trash, state: 'delete' },
    };
    public readonly Right: IconType = Icons.KeyRound;
    public readonly Tag: IconType = Icons.Tag;

    /** A level includes the lower ones: it shows all their icons. */
    public listLevelIcons(level: number): BadgeIcon[] {
        return Object.entries(this.Levels)
            .filter(([value]: [string, BadgeIcon]): boolean => Number(value) <= level)
            .map(([, entry]: [string, BadgeIcon]): BadgeIcon => entry);
    }
}

export const RightsIcons = new RightsIconsClass();
